module.exports = __webpack_public_path__ + "media/images/landing_page/2023/home_main_mobile2_old-eab5f8942210a0a79133556aa352f15b.png";